// @flow
import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import {
  MdDelete,
} from 'react-icons/lib/md';
import _ from 'lodash';
import i18n from 'i18n-js';

import type { ID_TYPE } from '../../../../types/common';
import DataTable from '../../../DataTable';
import TextColumn from '../../../DataTable/Columns/Text';
import HighlightColumn from '../../../DataTable/Columns/Highlight';
import ButtonColumn from '../../../DataTable/Columns/Button';
import type { GATE_TYPE } from '../../../../types/gates';
import * as gateActions from '../../../../actions/gates';
import * as closeableActions from '../../../../actions/closeable';
import * as selectors from '../../../../reducers';
import { FullLoader } from '../../../Loader';
import Popup from '../../../Popup';
import ConfirmDeletionPopup from '../../../ConfirmDeletionPopup';
import styles from '../backendExitMethodsView.css';
import {
  Loading, ConfirmDeletion,
} from '../../../CommonTexts';
import PlaceholderView from '../../../PlaceholderViews';
import PlaceholderImage from '../../../../../assets/images/genericph.png';


type ExitMethodListPropTypes = {
  onOpen: Function,
  gates: Array<GATE_TYPE>,
  isFetchingGates: boolean,
  popupAction: Function,
  currentGate: GATE_TYPE,
};


class BackendExitMethodsList extends React.Component<ExitMethodListPropTypes> {
  componentWillMount() {
    const { onOpen } = this.props;
    onOpen();
  }

  render() {
    const {
      gates,
      isFetchingGates,
      popupAction,
      currentGate,
    } = this.props;
    return (
      <div className={styles.list}>
        {
          !isFetchingGates
          && gates.length === 0
          && (
            <PlaceholderView
              image={PlaceholderImage}
              title={"Al parecer no se han encontrado puertas"}
              subtitle={"No hay datos que coincidan con los filtros establecidos"}
            />
          )
        }
        {
          isFetchingGates && (
            <FullLoader
              tint="main"
              title={Loading(i18n.t('common.gate', { count: 2 }))}
            />
          )
        }
        {
          !isFetchingGates
          && gates.length > 0
          && (
            <Fragment>
              <Popup
                id="confirmDeleteGate"
                theme="main"
                transitionType="slideDown"
                transitionMs={600}
              >
                {currentGate // La current gateway ya salio del estado inicial?
                  ? (<ConfirmDeletionPopup
                    onConfirm={() => popupAction()}
                    Icon={MdDelete}
                    descriptionText={ConfirmDeletion(currentGate.name)}
                  />) : (<Fragment />) }
              </Popup>
              <DataTable
                data={gates}
                columns={
                  [
                    HighlightColumn({ Header: 'Id', accessor: 'id', maxWidth: 50 }),
                    TextColumn({ Header: i18n.t('labels.name', { count: 1 }), accessor: 'name' }),
                    TextColumn({ Header: i18n.t('labels.identifier'), accessor: 'code' }),
                    ButtonColumn({
                      Header: '',
                      accessor: 'delete_button',
                      buttonProps: {
                        Icon: MdDelete,
                        title: '',
                        size: 'small',
                        isTransparent: true,
                        tint: 'error',
                        isOutlined: true,
                        iconPosition: 'right',
                      },
                      maxWidth: 50,
                    }),
                  ]
                }
                minRows={0}
                showPagination={false}
              />
            </Fragment>
          )
        }
      </div>
    );
  }
}


export default connect(
  (state) => {
    const profile = selectors.getProfileOfType(state, 'admin');
    const gates = selectors.getGates(state);
    return {
      isFetchingGates: selectors.areGatesFetching(state),
      gates,
      schoolId: profile && profile.school ? profile.school : -1,
      currentGate: selectors.getCurrentGate(state),
    };
  },
  dispatch => ({
    onOpen(schoolId: number) {
      dispatch(gateActions.startFetchingGates(schoolId));
    },
    buttonSelectGate(gateId: ID_TYPE) {
      dispatch(gateActions.selectGate(gateId));
    },
    removeGate(gateId: number, popupID: string) {
      dispatch(gateActions.removeGateStart(gateId));
      dispatch(closeableActions.close(popupID));
    },
    openPopup(id) {
      dispatch(closeableActions.open(id));
    },
  }),
  ({
    schoolId, gates, currentGate, ...stateProps
  }, {
    onOpen, removeGate, openPopup, buttonSelectGate, ...dispatchProps
  }, ownProps) => ({
    ...ownProps,
    ...stateProps,
    ...dispatchProps,
    currentGate,
    popupAction() {
      removeGate(currentGate.id, 'confirmDeleteGate');
    },
    onOpen() {
      onOpen(schoolId);
    },
    gates: gates.map(
      el => ({
        ...el,
        delete_button: {
          onClick: () => {
            buttonSelectGate(el.id);
            openPopup('confirmDeleteGate');
          },
        },
      }),
    ),
  }),
  {
    areStatesEqual(next, prev) {
      return _.isEqual(next.gates, prev.gates);
    },
  },
)(BackendExitMethodsList);



// WEBPACK FOOTER //
// ./src/scripts/components/views/BackendExitMethodsView/BackendExitMethodsDoorsList/index.jsx